import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiState {
  theme:         'light' | 'dark';
  searchQuery:   string;
  authModalOpen: boolean;
  authTab:       'login' | 'register';
  toggleTheme:   () => void;
  setSearchQuery: (q: string) => void;
  openAuthModal: (tab?: 'login' | 'register') => void;
  closeAuthModal: () => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      theme:         'light',
      searchQuery:   '',
      authModalOpen: false,
      authTab:       'login',

      toggleTheme: () =>
        set((s) => {
          const next = s.theme === 'light' ? 'dark' : 'light';
          document.documentElement.classList.toggle('dark', next === 'dark');
          return { theme: next };
        }),

      setSearchQuery: (q) => set({ searchQuery: q }),

      openAuthModal: (tab = 'login') => set({ authModalOpen: true, authTab: tab }),

      closeAuthModal: () => set({ authModalOpen: false }),
    }),
    {
      name: 'ui',
      partialize: (s) => ({ theme: s.theme }),
      onRehydrateStorage: () => (state) => {
        if (state?.theme === 'dark') document.documentElement.classList.add('dark');
      },
    },
  ),
);
